import { render, staticRenderFns } from "./jjfz.vue?vue&type=template&id=35399d82&scoped=true&"
import script from "./jjfz.vue?vue&type=script&lang=js&"
export * from "./jjfz.vue?vue&type=script&lang=js&"
import style0 from "./jjfz.vue?vue&type=style&index=0&id=35399d82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35399d82",
  null
  
)

export default component.exports